import { PriceStatus } from '@toggle/helpers';
import styled from 'styled-components';

import { priceChangeColors } from '~/utils/common/utils';

export const ColoredValue = styled.span<{ $status: PriceStatus }>`
  color: ${({ $status }) => priceChangeColors[$status]};
  display: inline-block;
`;

export const NonNumericText = styled.span``;

export const Root = styled.div`
  display: flex;
  flex-direction: row;
  justify-self: end;
  justify-content: end;
  min-width: 60px;
  gap: 12px;
`;
